import httpClient from "./httpClient";

/**
 * This function sets the auth token and attaches it to the axios instance created for every request being sent
 * @param {string} token
 */
export const setAuthToken = (token) => {
    if (token) {
        httpClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete httpClient.defaults.headers.common["Authorization"];
    }
};

export default setAuthToken;
